import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SegmentPool_instancep7dfbo63nk35 as SegmentPool_instance } from './SegmentPool.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  toByte4i43936u611k as toByte,
  toShort36kaw0zjdq3ex as toShort,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.n4g_1 = 8192;
        this.o4g_1 = 1024;
      }
      p4g() {
        return Segment().q4g();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function init_kotlinx_io_Segment(_this__u8e3s4) {
  _this__u8e3s4.o4e_1 = 0;
  _this__u8e3s4.p4e_1 = 0;
  _this__u8e3s4.q4e_1 = null;
  _this__u8e3s4.r4e_1 = false;
  _this__u8e3s4.s4e_1 = null;
  _this__u8e3s4.t4e_1 = null;
}
var SegmentClass;
function Segment() {
  if (SegmentClass === VOID) {
    class $ {
      s4f() {
        var tmp0_safe_receiver = this.q4e_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r4g();
        return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
      }
      static q4g() {
        var $this = createThis(this);
        init_kotlinx_io_Segment($this);
        $this.n4e_1 = new Int8Array(8192);
        $this.r4e_1 = true;
        $this.q4e_1 = null;
        return $this;
      }
      static s4g(data, pos, limit, shareToken, owner) {
        var $this = createThis(this);
        init_kotlinx_io_Segment($this);
        $this.n4e_1 = data;
        $this.o4e_1 = pos;
        $this.p4e_1 = limit;
        $this.q4e_1 = shareToken;
        $this.r4e_1 = owner;
        return $this;
      }
      a4f() {
        var tmp0_elvis_lhs = this.q4e_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = SegmentPool_instance.t4g();
          this.q4e_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var t = tmp;
        var tmp_0 = this.o4e_1;
        var tmp_1 = this.p4e_1;
        // Inline function 'kotlin.also' call
        t.u4g();
        return Segment().s4g(this.n4e_1, tmp_0, tmp_1, t, false);
      }
      v4f() {
        var result = this.s4e_1;
        if (!(this.t4e_1 == null)) {
          ensureNotNull(this.t4e_1).s4e_1 = this.s4e_1;
        }
        if (!(this.s4e_1 == null)) {
          ensureNotNull(this.s4e_1).t4e_1 = this.t4e_1;
        }
        this.s4e_1 = null;
        this.t4e_1 = null;
        return result;
      }
      b4f(segment) {
        segment.t4e_1 = this;
        segment.s4e_1 = this.s4e_1;
        if (!(this.s4e_1 == null)) {
          ensureNotNull(this.s4e_1).t4e_1 = segment;
        }
        this.s4e_1 = segment;
        return segment;
      }
      t4f(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount > 0 && byteCount <= (this.p4e_1 - this.o4e_1 | 0))) {
          var message = 'byteCount out of range';
          throw IllegalArgumentException().s2(toString(message));
        }
        var prefix;
        if (byteCount >= 1024) {
          prefix = this.a4f();
        } else {
          prefix = SegmentPool_instance.b3w();
          var tmp0 = this.n4e_1;
          var tmp2 = prefix.n4e_1;
          var tmp5 = this.o4e_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = this.o4e_1 + byteCount | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
        }
        prefix.p4e_1 = prefix.o4e_1 + byteCount | 0;
        this.o4e_1 = this.o4e_1 + byteCount | 0;
        if (!(this.t4e_1 == null)) {
          ensureNotNull(this.t4e_1).b4f(prefix);
        } else {
          prefix.s4e_1 = this;
          this.t4e_1 = prefix;
        }
        return prefix;
      }
      c4f() {
        // Inline function 'kotlin.check' call
        if (!!(this.t4e_1 == null)) {
          var message = 'cannot compact';
          throw IllegalStateException().o(toString(message));
        }
        if (!ensureNotNull(this.t4e_1).r4e_1)
          return this;
        var byteCount = this.p4e_1 - this.o4e_1 | 0;
        var availableByteCount = (8192 - ensureNotNull(this.t4e_1).p4e_1 | 0) + (ensureNotNull(this.t4e_1).s4f() ? 0 : ensureNotNull(this.t4e_1).o4e_1) | 0;
        if (byteCount > availableByteCount)
          return this;
        var predecessor = this.t4e_1;
        this.u4f(ensureNotNull(predecessor), byteCount);
        var successor = this.v4f();
        // Inline function 'kotlin.check' call
        if (!(successor == null)) {
          throw IllegalStateException().o('Check failed.');
        }
        SegmentPool_instance.c4g(this);
        return predecessor;
      }
      y4f(byte) {
        var _unary__edvuaz = this.p4e_1;
        this.p4e_1 = _unary__edvuaz + 1 | 0;
        this.n4e_1[_unary__edvuaz] = byte;
      }
      a4g(short) {
        var data = this.n4e_1;
        var limit = this.p4e_1;
        var _unary__edvuaz = limit;
        limit = _unary__edvuaz + 1 | 0;
        data[_unary__edvuaz] = toByte((short >>> 8 | 0) & 255);
        var _unary__edvuaz_0 = limit;
        limit = _unary__edvuaz_0 + 1 | 0;
        data[_unary__edvuaz_0] = toByte(short & 255);
        this.p4e_1 = limit;
      }
      v4e() {
        var _unary__edvuaz = this.o4e_1;
        this.o4e_1 = _unary__edvuaz + 1 | 0;
        return this.n4e_1[_unary__edvuaz];
      }
      x4e() {
        var data = this.n4e_1;
        var pos = this.o4e_1;
        var _unary__edvuaz = pos;
        pos = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlinx.io.and' call
        var tmp = (data[_unary__edvuaz] & 255) << 8;
        var _unary__edvuaz_0 = pos;
        pos = _unary__edvuaz_0 + 1 | 0;
        // Inline function 'kotlinx.io.and' call
        var tmp$ret$1 = data[_unary__edvuaz_0] & 255;
        var s = toShort(tmp | tmp$ret$1);
        this.o4e_1 = pos;
        return s;
      }
      u4f(sink, byteCount) {
        // Inline function 'kotlin.check' call
        if (!sink.r4e_1) {
          var message = 'only owner can write';
          throw IllegalStateException().o(toString(message));
        }
        if ((sink.p4e_1 + byteCount | 0) > 8192) {
          if (sink.s4f())
            throw IllegalArgumentException().xd();
          if (((sink.p4e_1 + byteCount | 0) - sink.o4e_1 | 0) > 8192)
            throw IllegalArgumentException().xd();
          var tmp0 = sink.n4e_1;
          var tmp2 = sink.n4e_1;
          var tmp5 = sink.o4e_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = sink.p4e_1;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
          sink.p4e_1 = sink.p4e_1 - sink.o4e_1 | 0;
          sink.o4e_1 = 0;
        }
        var tmp0_0 = this.n4e_1;
        var tmp2_0 = sink.n4e_1;
        var tmp4 = sink.p4e_1;
        var tmp6 = this.o4e_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_0 = this.o4e_1 + byteCount | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = tmp0_0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp_0, tmp2_0, tmp4, tmp6, endIndex_0);
        sink.p4e_1 = sink.p4e_1 + byteCount | 0;
        this.o4e_1 = this.o4e_1 + byteCount | 0;
      }
      g4f(dst, dstStartOffset, dstEndOffset) {
        var len = dstEndOffset - dstStartOffset | 0;
        var tmp0 = this.n4e_1;
        var tmp6 = this.o4e_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex = this.o4e_1 + len | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp = tmp0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp, dst, dstStartOffset, tmp6, endIndex);
        this.o4e_1 = this.o4e_1 + len | 0;
      }
      q4f(src, srcStartOffset, srcEndOffset) {
        var tmp2 = this.n4e_1;
        // Inline function 'kotlin.collections.copyInto' call
        var destinationOffset = this.p4e_1;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp = src;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp, tmp2, destinationOffset, srcStartOffset, srcEndOffset);
        this.p4e_1 = this.p4e_1 + (srcEndOffset - srcStartOffset | 0) | 0;
      }
      v2() {
        return this.p4e_1 - this.o4e_1 | 0;
      }
      p4f() {
        return this.n4e_1.length - this.p4e_1 | 0;
      }
      v4g(readOnly) {
        return this.n4e_1;
      }
      e4f(index) {
        return this.n4e_1[this.o4e_1 + index | 0];
      }
      w4g(index, value) {
        this.n4e_1[this.p4e_1 + index | 0] = value;
      }
      x4g(index, b0, b1) {
        var d = this.n4e_1;
        var l = this.p4e_1;
        d[l + index | 0] = b0;
        d[(l + index | 0) + 1 | 0] = b1;
      }
      y4g(index, b0, b1, b2) {
        var d = this.n4e_1;
        var l = this.p4e_1;
        d[l + index | 0] = b0;
        d[(l + index | 0) + 1 | 0] = b1;
        d[(l + index | 0) + 2 | 0] = b2;
      }
      z4g(index, b0, b1, b2, b3) {
        var d = this.n4e_1;
        var l = this.p4e_1;
        d[l + index | 0] = b0;
        d[(l + index | 0) + 1 | 0] = b1;
        d[(l + index | 0) + 2 | 0] = b2;
        d[(l + index | 0) + 3 | 0] = b3;
      }
    }
    initMetadataForClass($, 'Segment');
    SegmentClass = $;
  }
  return SegmentClass;
}
function isEmpty(_this__u8e3s4) {
  return _this__u8e3s4.v2() === 0;
}
var SegmentCopyTrackerClass;
function SegmentCopyTracker() {
  if (SegmentCopyTrackerClass === VOID) {
    class $ {}
    initMetadataForClass($, 'SegmentCopyTracker');
    SegmentCopyTrackerClass = $;
  }
  return SegmentCopyTrackerClass;
}
var AlwaysSharedCopyTrackerClass;
function AlwaysSharedCopyTracker() {
  if (AlwaysSharedCopyTrackerClass === VOID) {
    class $ extends SegmentCopyTracker() {
      constructor() {
        AlwaysSharedCopyTracker_instance = null;
        super();
        AlwaysSharedCopyTracker_instance = this;
      }
      r4g() {
        return true;
      }
      u4g() {
        return Unit_instance;
      }
    }
    initMetadataForObject($, 'AlwaysSharedCopyTracker');
    AlwaysSharedCopyTrackerClass = $;
  }
  return AlwaysSharedCopyTrackerClass;
}
var AlwaysSharedCopyTracker_instance;
function AlwaysSharedCopyTracker_getInstance() {
  if (AlwaysSharedCopyTracker_instance === VOID)
    new (AlwaysSharedCopyTracker())();
  return AlwaysSharedCopyTracker_instance;
}
function indexOf(_this__u8e3s4, byte, startOffset, endOffset) {
  // Inline function 'kotlin.require' call
  if (!(0 <= startOffset ? startOffset < _this__u8e3s4.v2() : false)) {
    var message = '' + startOffset;
    throw IllegalArgumentException().s2(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(startOffset <= endOffset ? endOffset <= _this__u8e3s4.v2() : false)) {
    var message_0 = '' + endOffset;
    throw IllegalArgumentException().s2(toString(message_0));
  }
  var p = _this__u8e3s4.o4e_1;
  var data = _this__u8e3s4.v4g(true);
  var inductionVariable = startOffset;
  if (inductionVariable < endOffset)
    do {
      var idx = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (data[p + idx | 0] === byte) {
        return idx;
      }
    }
     while (inductionVariable < endOffset);
  return -1;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  AlwaysSharedCopyTracker_getInstance as AlwaysSharedCopyTracker_getInstance35mam6kufibag,
  Companion_instance as Companion_instance1evlhu73xfb8l,
  indexOf as indexOf1i2yqitz2lwb6,
  isEmpty as isEmpty39cntv762vey6,
};
//endregion

//# sourceMappingURL=Segment.mjs.map
